<template>
  <div>
    <div
      v-for="parent in documentTemplateVariablesHelp"
      :key="parent.parent"
    >
      <div class="font-weight-bold text-uppercase mt-4 mb-1">
        {{ parent.parent }}
      </div>
      <div
        v-for="variable in parent.children"
        :key="variable.id"
        class="mb-2"
      >
        <v-row
          class="radius-5 pa-2 elevation-4"
          style="border: 1px solid #d6d6d6"
          no-gutters
          align="center"
        >
          <v-col>
            <div class="caption grey--text text--darken-2">
              {{ variable.label }}
            </div>
            <div>
              {{ variable.template }}
            </div>
          </v-col>
          <v-col class="shrink">
            <v-icon
              :key="'icon_' + variable.id"
              @click="$emit('add', variable.template)"
            >
              add_circle
            </v-icon>
          </v-col>
        </v-row>
        <div class="caption grey--text mt-1 pl-2">
          {{ variable.example }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import DocumentTemplate from '@/models/DocumentTemplate'
  import { groupBy } from 'lodash'

  export default {
    name: 'DocumentTemplateEditHelp',
    data() {
      return {
        documentTemplateVariablesHelp: []
      }
    },
    created() {
      this.fetchHelp()
    },
    methods: {
      async fetchHelp() {
        let data = await DocumentTemplate.api.fetchHelp()

        let grouped = groupBy(data, v => v.parent)

        this.documentTemplateVariablesHelp = Object.keys(grouped).map(parent => {
          return {
            parent: parent,
            children: grouped[parent].map(child => {
              return {
                id: child.id,
                template: '{{ ' + child.id + ' }}',
                parent: child.parent,
                label: child.label,
                example: child.example
              }
            })
          }
        })
      }
    }
  }
</script>

<style scoped>

</style>
